import React, { Component } from 'react'
import PropTypes from 'prop-types';
import StyleSheet from '../../styles'
import { colorPalette } from '../../styles'
import {Authorization} from '../../utils'
import {IndexContext, LinkButton} from '..'

export class Pagination extends Component{

  static propTypes = {
    totalPages:     PropTypes.number.isRequired,
    page:           PropTypes.number.isRequired,
    onPageSelected: PropTypes.func.isRequired,
    showAll:        PropTypes.bool,
    showNext:       PropTypes.bool,
    showPrev:       PropTypes.bool,
    showFirst:      PropTypes.oneOfType([
                                PropTypes.bool,
                                PropTypes.oneOf(['auto'])
                              ]),
    showLast:       PropTypes.oneOfType([
                                PropTypes.bool,
                                PropTypes.oneOf(['auto'])
                              ]),
    segmentSize:    PropTypes.number,
    theme:          PropTypes.string.isRequired
  }

  static defaultProps = {
    showNext:   false,
    showPrev:   false,
    showFirst:  'auto',
    showLast:   'auto',
    segmentSize: 5,
    className: '',
    theme: 'light'
  }

  get styles() {
    const { theme } = this.props
    return (theme === 'light') ? stylesLight : stylesDark
  }

  shouldShowAll = () => {
    return Authorization.admin && this.props.showAll
  }

  shouldShowFirst = (startIndex, endIndex) => {
    const { showFirst, totalPages } = this.props
    if (showFirst === true) {
     return totalPages > 1
    } else if (showFirst === 'auto') {
      return startIndex > 1
    }
  }

  shouldShowLast = (startIndex, endIndex) => {
    const { showLast, totalPages } = this.props
    if (showLast === true) {
      return totalPages > 1
    } else if (showLast === 'auto') {
      return endIndex < totalPages
    }
  }

  renderButtons = () => {
    const { showNext, showPrev, page, totalPages, segmentSize } = this.props
    if(totalPages <= 1) return false

    const buttons = []

    let startIndex = page - Math.floor(segmentSize / 2)
    if(startIndex < 1) {
      startIndex = 1
    }

    let endIndex = startIndex + (segmentSize - 1)
    if(endIndex > totalPages) {
      endIndex = totalPages
      startIndex = Math.max(endIndex - segmentSize + 1, 1)
    }

    if(this.shouldShowFirst(startIndex, endIndex)) {
      buttons.push(this.renderButton('First', 1))
    }

    if(showPrev && page > 1) {
      buttons.push(this.renderButton('<', page - 1))
    }

    for(let index = startIndex; index <= endIndex; index++){
      buttons.push(this.renderButton(index, index, index === page))
    }

    if(showNext && page < totalPages) {
      buttons.push(this.renderButton('>', page + 1))
    }

    if(this.shouldShowLast(startIndex, endIndex)) {
      buttons.push(this.renderButton('Last', totalPages))
    }

    if(this.shouldShowAll()) {
      buttons.push(this.renderButton('All', 0, page === 0))
    }

    return buttons
  }

  renderButton = (text, index, disabled) => (
    disabled ?
      <span key={`${text}-${index}`} className={this.styles('pageButton', 'activeStyle')}>{text}</span> :
      <LinkButton key={`${text}-${index}`} className={this.styles('pageButton')} onClick={() => this.props.onPageSelected(index)}>{text}</LinkButton>
    )

  render = () => {
    const { totalPages } = this.props
    if(totalPages <= 1) {
      return null
    }

    return (
      <div className={`${this.styles.paginationContainer} ${this.props.className}`}>
        {this.renderButtons()} <br style={{clear: 'both'}}/>
      </div>
    )
  }
}

function buildTheme(themeName) {
  const pageButtonColor = (themeName === 'light') ? colorPalette.primary[2].hex() : '#ffffff'

  return {
    paginationContainer: {
      margin: 5,
      padding:   '5px 10px',
      textAlign: 'right',
      '-webkit-touch-callout': 'none',
      '-webkit-user-select': 'none',
       '-khtml-user-select': 'none',
         '-moz-user-select': 'none',
          '-ms-user-select': 'none',
              'user-select': 'none',
      '& button$pageButton': {
        textDecoration: 'none',
        color: pageButtonColor,
      },
      '@media print': {
        display: 'none'
      }
    },
    pageButton: {
      'span&, button&': {
        display: 'inline-block',
        cursor:  'pointer',

        height: '35px',
        minWidth: '35px',
        paddingLeft: '5px',
        paddingRight: '5px',
        boxSizing: 'border-box',

        borderRadius: '3px',
        border: 'solid 1px #c7c7c7 !important',

        lineHeight: '35px',
        verticalAlign: 'middle',
        textAlign: 'center',

        fontFamily: 'Montserrat,sans-serif',
        fontSize: '14px',
        fontWeight: '500',

        marginRight: '9px',
      }
    },
    activeStyle: {
      backgroundColor: '#586c7b',
      border: 'solid 1px #586c7b',
      color: '#ffffff',
    }
  }
}

const stylesLight = StyleSheet(buildTheme('light'))
const stylesDark = StyleSheet(buildTheme('dark'))

export default class PaginationWrapper extends Component {
  render = () =>
    <IndexContext.Consumer>
      {({onPageChange, ...value}) => <Pagination onPageSelected={onPageChange} {...value} {...this.props} />}
    </IndexContext.Consumer>
}